var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-drawer',{attrs:{"placement":"right","closable":false,"visible":_vm.showDrawer,"width":_vm.computedWidth,"destroyOnClose":true},on:{"close":_vm.close}},[_vm._t("default"),(_vm.showDrawer)?_c('div',{staticClass:"closer",on:{"click":_vm.close}},[_c('a-icon',{attrs:{"type":"close"}})],1):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }